import { Icon, TIconVariant } from '@/shared/ui/icon'
import { TransactionStatusType } from '../../types'
import { useStyles } from './styles'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'

type TransactionStatusProps = {
  variant: TransactionStatusType
}

export const TransactionStatus = (props: TransactionStatusProps) => {
  const { variant } = props
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.shop

  const text = variant === 'processing' ? texts.transactionProcessing : texts.transactionSuccess
  const icon: TIconVariant = variant === 'processing' ? 'transactionProcessing' : 'transactionSuccess'
  const { classes } = useStyles()
  return (
    <div
      className={classes.root}
      data-variant={variant}
    >
      <Icon
        view={icon}
        width={32}
      />
      <span>{text}</span>
      <Icon
        view="close"
        style={{ filter: 'brightness(30%)', top: '4px', right: '4px', position: 'absolute' }}
      />
    </div>
  )
}
